export default () => ({
  ringingState: false,
  testRingingState: false,
  testCallerState: false,
  testItrState: false
})
